document.addEventListener("DOMContentLoaded", () => {
  const products = window.bookmatchProducts || [];
  const BOOKMATCH_TRACKING_VERSION = "2.0";
  const RECOMMENDATION_LIST_MAX_LENGTH = 240;

  window.BookMatchSession = null;

const CONFIG = {

  MAX_RESULTS: 10,

  COMPACT_FROM: 1,

  MATCH_PERCENT: {
    min: 20,
    max: 99,
    factor: 0.55
  },

  SCORE: {
    genre: 50,
    trope: 25,
    mood: 15,
    feature: 10,
    spice: 15,
    series: 0,

    extraGenre: 8,
    extraTrope: 10,
    extraFeature: 6
  }

};
  const screens = {
    start: document.querySelector('[data-bm-screen="start"]'),
    quiz: document.querySelector('[data-bm-screen="quiz"]'),
    loading: document.querySelector('[data-bm-screen="loading"]'),
    result: document.querySelector('[data-bm-screen="result"]')
  };

  const startButton = document.querySelector("[data-bm-start]");
  const restartButton = document.querySelector("[data-bm-restart]");
  const backButton = document.querySelector("[data-bm-back]");
  const questionEl = document.querySelector("[data-bm-question]");
  const questionCopyEl = document.querySelector("[data-bm-copy]");
  const answersEl = document.querySelector("[data-bm-answers]");
  const countEl = document.querySelector("[data-bm-count]");
  const progressEl = document.querySelector("[data-bm-progress]");
  const readerTypeEl = document.querySelector("[data-bm-reader-type]");
  const readerTextEl = document.querySelector("[data-bm-reader-text]");
  const readerVibeEl = document.querySelector("[data-bm-reader-vibe]");
  const readerCardEl = document.querySelector("[data-bm-reader-card]");
const readerIconEl = document.querySelector("[data-bm-reader-icon]");
  const resultsEl = document.querySelector("[data-bm-results]");
  const startScreen = document.querySelector('[data-bm-screen="start"]');
const ownedToggle = document.querySelector("[data-bm-owned-toggle]");
const ownedBox = document.querySelector("[data-bm-owned-box]");
const ownedSearch = document.querySelector("[data-bm-owned-search]");
const ownedList = document.querySelector("[data-bm-owned-list]");
const ownedSkip = document.querySelector("[data-bm-owned-skip]");
const refineButtons = document.querySelectorAll("[data-bm-refine]");
  let currentQuestion = 0;
  let answerHistory = [];
  let userProfile = createEmptyProfile();
let refineModes = [];
let ownedProductIds = [];
  const questions = [
    {
      title: "Welches Regal zieht dich magisch an?",
      copy: "Stell dir vor, du betrittst eine riesige Bibliothek. Welches Regal zieht dich magisch an?",
      answers: [
        { icon: "🖤", title: "Das verbotene Regal", subtitle: "Düstere Geschichten voller Geheimnisse", scores: { genres: ["dark_romance"], moods: ["dark"], path: "dark", reader: { darkQueen: 3 } } },
        { icon: "🐉", title: "Magische Welten", subtitle: "Drachen, Fae und epische Abenteuer", scores: { genres: ["fantasy", "romantasy"], features: ["dragon", "magic"], path: "fantasy", reader: { fantasyExplorer: 3 } } },
        { icon: "💖", title: "Große Gefühle", subtitle: "Herzklopfen garantiert", scores: { genres: ["romance", "contemporary_romance"], moods: ["emotional"], path: "romance", reader: { romanceAddict: 3 } } },
        { icon: "🏒", title: "Sport Romance", subtitle: "Liebe auf und neben dem Spielfeld", scores: { genres: ["sports_romance"], features: ["hockey", "football"], path: "sports", reader: { romanceAddict: 2 } } },
        { icon: "☕", title: "Cozy Corner", subtitle: "Wohlfühlbücher zum Einkuscheln", scores: { genres: ["cozy_romance"], moods: ["cozy", "humor"], path: "cozy", reader: { cozyDreamer: 3 } } },
      ]
    },
    {
      title: "Wie heiß darf es zwischen den Seiten werden?",
      copy: "Jede Geschichte knistert anders. Wie viel darf es dieses Mal sein?",
      answers: [
        { icon: "🌸", title: "Nur Herzklopfen", subtitle: "Bitte eher süß als spicy", scores: { spice: 0, reader: { cozyDreamer: 1 } } },
        { icon: "🌶", title: "Ein bisschen Knistern", subtitle: "Romantik mit kleinen Funken", scores: { spice: 1, reader: { romanceAddict: 1 } } },
        { icon: "🔥", title: "Ordentlich Funken", subtitle: "Es darf schon heiß werden", scores: { spice: 2, reader: { romanceAddict: 1 } } },
        { icon: "🖤", title: "Keine Zurückhaltung", subtitle: "Bitte intensiv und spicy", scores: { spice: 3, reader: { darkQueen: 2 } } }
      ]
    },
    {
      title: "Welche Geschichte würdest du sofort ausleihen?",
      copy: "Eine unbekannte Person drückt dir ein Buch in die Hand. Welche Geschichte hoffst du darin zu finden?",
      answers: [
        { icon: "⚔️", title: "Hass trifft Knistern", subtitle: "Erst streiten, dann verlieben", scores: { tropes: ["enemies_to_lovers"] } },
        { icon: "💍", title: "Nur so tun", subtitle: "Fake Dating mit echten Gefühlen", scores: { tropes: ["fake_dating"] } },
        { icon: "🚪", title: "Viel zu nah", subtitle: "Forced Proximity vom Feinsten", scores: { tropes: ["forced_proximity"] } },
        { icon: "🫶", title: "Gefundenes Zuhause", subtitle: "Eine Gruppe, die sich wie Familie anfühlt", scores: { tropes: ["found_family"], reader: { cozyDreamer: 1 } } },
        { icon: "🖤", title: "Problematisch interessant", subtitle: "Moralisch grau, aber leider spannend", scores: { tropes: ["morally_grey"], reader: { darkQueen: 2 } } },
        {
  icon: "🖤",
  title: "Touch Her and Die",
  subtitle: "Beschützerisch bis zur Besessenheit",
  scores: {
    tropes: ["touch_her_and_die"],
    reader: { darkQueen: 1 }
  }
},
        { icon: "🔥", title: "Langsam brennend", subtitle: "Slow Burn mit maximalem Herzklopfen", scores: { tropes: ["slow_burn"], reader: { romanceAddict: 1 } } }
      ]
    },
    {
      title: "Wohin soll dich die Geschichte entführen?",
      copy: "In welcher Welt möchtest du die nächsten Stunden verbringen?",
      answers: [
        { icon: "🏫", title: "Campus", subtitle: "College, Uni und neue Anfänge", scores: { features: ["college", "university"] } },
        { icon: "👑", title: "Königshaus", subtitle: "Royals, Machtspiele und verbotene Gefühle", scores: { features: ["royalty"], genres: ["fantasy", "romantasy"] } },
        { icon: "🌃", title: "Großstadt", subtitle: "Nächte, Geheimnisse und Drama", scores: { features: ["big_city"] } },
        { icon: "🏠", title: "Kleinstadt", subtitle: "Wohlfühlorte und vertraute Gesichter", scores: { features: ["small_town"], reader: { cozyDreamer: 1 } } },
        { icon: "🖤", title: "Unterwelt", subtitle: "Mafia, Gefahr und dunkle Versprechen", scores: { features: ["mafia"], genres: ["dark_romance"], reader: { darkQueen: 2 } } }
      ]
    },
   {
  title: "Dein perfekter Leseabend...",
  copy: "Draußen regnet es, dein Lieblingsgetränk steht bereit und niemand stört dich. Worauf hast du heute Lust?",
  answers: [
    {
      icon: "📕",
      title: "Einzelband",
      subtitle: "Eine abgeschlossene Geschichte",
      scores: { series: "Einzelband" }
    },
    {
      icon: "📚",
      title: "Reihe",
      subtitle: "Eine Reihe, in der ich mich verlieren kann",
      scores: { series: "Reihe" }
    },
    {
      icon: "🎲",
      title: "Überrasch mich",
      subtitle: "Ich bin für alles offen",
      scores: {}
    }
  ]
},
{
title: "🚫 Was möchtest du heute bewusst ausschließen?",
  copy: "Wähle das aus, worauf du heute keine Lust hast.",
  exclude: true,
  answers: [
    {
      icon: "🖤",
title: "🚫 Dark Romance",
      subtitle: "Heute bitte nichts Düsteres",
      scores: { excludeGenres: ["dark_romance"] }
    },
    {
      icon: "🐉",
      title: "🚫Romantasy",
      subtitle: "Keine Magie heute",
      scores: { excludeGenres: ["romantasy", "fantasy"] }
    },
    {
      icon: "🏒",
      title: "🚫Sport Romance",
      subtitle: "Heute kein Sport",
      scores: { excludeGenres: ["sports_romance"] }
    },
    {
      icon: "☕",
      title: "🚫Cozy Romance",
      subtitle: "Nicht nach Wohlfühlbüchern",
      scores: { excludeGenres: ["cozy_romance"] }
    },
    {
  icon: "❤️",
  title: "🚫Romance",
  subtitle: "Heute keine klassische Romance",
  scores: { excludeGenres: ["romance", "contemporary_romance"] }
},
{
  icon: "➡️",
title: "✨ Ich bin für alles offen",
subtitle: "Keine Bücher ausschließen",
  scores: {}
}
  ]
},
{
  title: "Wann möchtest du dein nächstes Buch lesen?",
  copy: "Sollen wir Vorbestellungen berücksichtigen?",
  answers: [
    {
      icon: "📦",
      title: "Nur sofort lieferbare Bücher",
      subtitle: "Vorbestellungen ausblenden",
      scores: { hidePreorders: true }
    },
    {
      icon: "✨",
      title: "Vorbestellungen anzeigen",
      subtitle: "Auch kommende Highlights entdecken",
      scores: { showPreorders: true }
    },
    {
      icon: "🎲",
      title: "Ist mir egal",
      subtitle: "Zeig mir einfach die besten Treffer",
      scores: {}
    }
  ]
}
];

const readerTypes = {
    darkQueen: {
        color: "dark",
        icon: "🌙",
      title: " Die verbotene Bibliothekarin",
      text: "Du kannst keinem düsteren Buch widerstehen. Moralisch graue Figuren, intensive Emotionen und Geschichten, die dich bis tief in die Nacht wachhalten, sind genau dein Zuhause.",
      vibe: ["🌙 2 Uhr nachts", "🔥 intensiver Spice", "🖤 moralisch graue Figuren", "⚠️ Taschentücher bereit"]
    },
    fantasyExplorer: {
      icon: "🐉",
      color: "fantasy",
      title: " Die Weltenwanderin",
      text: "Du möchtest in fremde Welten eintauchen, Magie entdecken und jedes Abenteuer miterleben. Je größer das Worldbuilding, desto besser.",
      vibe: ["🐉 Drachen", "✨ Magie", "🗺 neue Welten", "⚔️ großes Abenteuer"]
    },
    romanceAddict: {
      icon: "💖",
      color: "romance",
      title: " Die Herzsammlerin",
      text: "Für dich stehen große Gefühle im Mittelpunkt. Du liebst Chemie, Herzklopfen und Figuren, in die man sich einfach verlieben muss.",
      vibe: ["💖 Herzklopfen", "🥹 große Gefühle", "🌶 knisternde Chemie", "📖 Happy-End-Hoffnung"]
    },
    cozyDreamer: {
      icon: "☕",
      color: "cozy",
      title: " Die Geschichtensammlerin",
      text: "Du suchst Bücher, die sich wie eine warme Decke anfühlen. Humor, Wohlfühlmomente und liebenswerte Figuren machen dein perfektes Leseerlebnis aus.",
      vibe: ["☕ Tee", "🕯 Kerze", "🌧 Regen am Fenster", "🍂 Wohlfühlvibes"]
    }
  };

  function createEmptyProfile() {
return {
  genres: [],
  tropes: [],
  moods: [],
  features: [],
  excludeGenres: [],
  excludeTropes: [],
  excludeFeatures: [],
      spice: null,
series: null,
path: null,
hidePreorders: false,
showPreorders: false,
reader: {
        darkQueen: 0,
        fantasyExplorer: 0,
        romanceAddict: 0,
        cozyDreamer: 0
      }
    };
  }
function renderOwnedList(searchTerm = "") {
  if (!ownedList) return;

  const term = searchTerm.trim().toLowerCase();

  const visibleProducts = products
    .filter(product => product.title.toLowerCase().includes(term))
    .slice(0, 30);

  ownedList.innerHTML = visibleProducts.map(product => `
    <button
      type="button"
      class="bm-owned-item ${ownedProductIds.includes(product.id) ? "is-selected" : ""}"
      data-owned-product-id="${product.id}"
    >
      ${product.image ? `<img src="${product.image}" alt="${product.title}">` : ""}
      <span>${product.title}</span>
      <strong>${ownedProductIds.includes(product.id) ? "✓" : "+"}</strong>
    </button>
  `).join("");
}
  function showScreen(name) {
    Object.values(screens).forEach(screen => {
      if (screen) screen.hidden = true;
    });

    if (screens[name]) screens[name].hidden = false;
  }

  function addScores(scores = {}) {
 [
  "genres",
  "tropes",
  "moods",
  "features",
  "excludeGenres",
  "excludeTropes",
  "excludeFeatures"
].forEach(key => {
  if (scores[key]) {
    userProfile[key].push(...scores[key]);
  }
});

    if (typeof scores.spice === "number") userProfile.spice = scores.spice;
    if (scores.series) userProfile.series = scores.series;
if (scores.path) userProfile.path = scores.path;
if (scores.hidePreorders) userProfile.hidePreorders = true;
if (scores.showPreorders) userProfile.showPreorders = true;
    if (scores.reader) {
      Object.keys(scores.reader).forEach(key => {
        userProfile.reader[key] += scores.reader[key];
      });
    }
  }

  function rebuildProfile(history) {
    const oldProfile = userProfile;
    userProfile = createEmptyProfile();

    history.forEach(scores => addScores(scores));

    const rebuiltProfile = userProfile;
    userProfile = oldProfile;

    return rebuiltProfile;
  }
function getCurrentQuestion() {
  const question = questions[currentQuestion];

  if (currentQuestion !== 2) {
    return question;
  }
  if (currentQuestion !== 2) return question;

  if (userProfile.path === "fantasy") {
    return {
      title: "Welche Magie ruft nach dir?",
      copy: "Zwischen den Regalen flackert ein Licht. Welche Welt öffnet sich vor dir?",
      answers: [
        { icon: "🐉", title: "Drachen", subtitle: "Episch, wild und voller Feuer", scores: { features: ["dragon"], reader: { fantasyExplorer: 2 } } },
        { icon: "✨", title: "Fae", subtitle: "Schön, gefährlich und nie ganz ehrlich", scores: { features: ["fae"], reader: { fantasyExplorer: 2 } } },
        { icon: "🧛", title: "Vampire", subtitle: "Dunkel, verführerisch und unsterblich", scores: { features: ["vampire"], reader: { darkQueen: 1, fantasyExplorer: 1 } } },
        { icon: "🧙", title: "Hexen", subtitle: "Magie, Geheimnisse und alte Kräfte", scores: { features: ["witch", "magic"], reader: { fantasyExplorer: 2 } } }
      ]
    };
  }

  if (userProfile.path === "dark") {
    return {
      title: "Welche Gefahr reizt dich am meisten?",
      copy: "Du gehst tiefer in die verbotene Abteilung. Was darf dort auf dich warten?",
      answers: [
        { icon: "🖤", title: "Morally Grey", subtitle: "Problematisch, aber leider spannend", scores: { tropes: ["morally_grey"], reader: { darkQueen: 2 } } },
        { icon: "🔪", title: "Düstere Spannung", subtitle: "Es darf unangenehm intensiv werden", scores: { moods: ["dark", "suspense"], reader: { darkQueen: 2 } } },
        { icon: "🏙", title: "Mafia", subtitle: "Gefahr, Macht und dunkle Versprechen", scores: { features: ["mafia"], reader: { darkQueen: 2 } } },
        { icon: "🔥", title: "Slow Burn", subtitle: "Langsam, intensiv und kaum auszuhalten", scores: { tropes: ["slow_burn"], reader: { romanceAddict: 1, darkQueen: 1 } } }
      ]
    };
  }

  if (userProfile.path === "cozy") {
    return {
      title: "Was macht dein Wohlfühlbuch perfekt?",
      copy: "Du sinkst in einen Sessel. Was sollte zwischen den Seiten auf dich warten?",
      answers: [
        { icon: "🫶", title: "Found Family", subtitle: "Menschen, die sich wie Zuhause anfühlen", scores: { tropes: ["found_family"], moods: ["cozy"], reader: { cozyDreamer: 2 } } },
        { icon: "😂", title: "Humor", subtitle: "Bitte leicht, warm und charmant", scores: { moods: ["humor", "light"], reader: { cozyDreamer: 2 } } },
        { icon: "🏠", title: "Small Town Vibes", subtitle: "Gemütliche Orte und vertraute Gesichter", scores: { features: ["small_town"], reader: { cozyDreamer: 2 } } },
        { icon: "💖", title: "Herzklopfen", subtitle: "Romantisch, aber nicht zu schwer", scores: { genres: ["romance"], moods: ["emotional"], reader: { romanceAddict: 1, cozyDreamer: 1 } } }
      ]
    };
  }
if (userProfile.path === "sports") {
  return {
    title: "Welche Sport Romance lässt dein Herz höherschlagen?",
    copy: "Der Schlusspfiff ist noch weit entfernt. Was suchst du?",
    answers: [
      {
        icon: "🏒",
        title: "Hockey",
        subtitle: "Raue Kerle mit weichem Kern",
        scores: {
          features: ["hockey"]
        }
      },
      {
        icon: "🏈",
        title: "Football",
        subtitle: "Teamgeist und große Gefühle",
        scores: {
          features: ["football"]
        }
      },
      {
        icon: "❤️",
        title: "Teamchemie",
        subtitle: "Found Family und Umkleidekabinen",
        scores: {
          tropes: ["found_family"]
        }
      },
      {
        icon: "🔥",
        title: "Rivalen",
        subtitle: "Sportlicher Ehrgeiz trifft Herzklopfen",
        scores: {
          tropes: ["enemies_to_lovers"]
        }
      }
    ]
  };
}
  return question;
}
function answerHasProducts(answer) {
  const scores = answer.scores || {};

  const checks = [
    ["genres", "genres"],
    ["tropes", "tropes"],
    ["moods", "moods"],
    ["features", "features"]
  ];

  const hasCheck = checks.some(([scoreKey]) => Array.isArray(scores[scoreKey]));

  if (!hasCheck) return true;

  return products.some(product => {
    return checks.some(([scoreKey, productKey]) => {
      const wanted = scores[scoreKey];
      const productValues = product[productKey];

      if (!Array.isArray(wanted) || !Array.isArray(productValues)) return false;

      return wanted.some(value => productValues.includes(value));
    });
  });
}
  function renderQuestion() {
const question = getCurrentQuestion();
    if (!question) return;

    answersEl.classList.remove("is-visible");

    questionEl.textContent = question.title;
    questionCopyEl.textContent = question.copy || "";

    const progressTexts = [
      "Das dauert weniger als eine Minute ✨",
      "Du bist drin in der Bibliothek 📚",
      "Halbzeit, dein Match wird klarer 🔮",
      "Fast geschafft 🖤",
      "Letzte Frage, dann suchen wir dein Buch ✨"
    ];

    countEl.textContent = `Frage ${currentQuestion + 1} von ${questions.length} · ${progressTexts[currentQuestion] || "Fast geschafft ✨"}`;
    progressEl.style.width = `${((currentQuestion + 1) / questions.length) * 100}%`;

    if (backButton) backButton.hidden = currentQuestion === 0;

const visibleAnswers = question.answers.filter(answerHasProducts);

answersEl.innerHTML = visibleAnswers.map((answer, index) => `
      <button type="button" class="bm-answer-card" data-answer-index="${index}">
        <div class="bm-answer-icon">${answer.icon || "📚"}</div>
        <h3>${answer.title || ""}</h3>
        ${answer.subtitle ? `<p>${answer.subtitle}</p>` : ""}
      </button>
    `).join("");

setTimeout(() => {
  answersEl.classList.add("is-visible");

  if (window.innerWidth < 768) {
    const quizEl = document.querySelector(".bm-bookmatch-quiz");
    const y = quizEl.getBoundingClientRect().top + window.pageYOffset - 120;

    window.scrollTo({
      top: y,
      behavior: "smooth"
    });
  }
}, 20);

    answersEl.querySelectorAll("[data-answer-index]").forEach(button => {
      button.addEventListener("click", () => {
const answer = visibleAnswers[Number(button.dataset.answerIndex)];

        button.classList.add("is-selected");

        setTimeout(() => {
          answerHistory.push(answer.scores || {});
          userProfile = rebuildProfile(answerHistory);
          currentQuestion += 1;

          if (currentQuestion >= questions.length) {
            showScreen("loading");
            setTimeout(renderResults, 1200);
          } else {
            renderQuestion();
          }
        }, 180);
      });
    });
  }
function createScoreContext(product) {

  return {

    product,

    score: 0,

    reasons: [],

    summary: [],

    matches: {
      genre: false,
      trope: false,
      mood: false,
      feature: false,
      spice: false,
      series: false
    }

  };

}

function addReason(ctx, key, label, value = null) {

  ctx.matches[key] = true;

  if (value) {
    ctx.reasons.push(value);
  }

  if (label && !ctx.summary.includes(label)) {
    ctx.summary.push(label);
  }

}
function scoreGenres(ctx, userProfile) {

  const productGenres = Array.isArray(ctx.product.genres)
    ? ctx.product.genres
    : [];

  let hits = 0;

  userProfile.genres.forEach(value => {

    if (!productGenres.includes(value)) return;

    hits++;

    ctx.score += CONFIG.SCORE.genre;

    addReason(
      ctx,
      "genre",
      "📚 Genre passt",
      value
    );

  });

  if (hits === 0 && userProfile.genres.length) {
    ctx.score -= 80;
  }

  ctx.score += hits * CONFIG.SCORE.extraGenre;

}
function scoreTropes(ctx, userProfile) {

  const productTropes = Array.isArray(ctx.product.tropes)
    ? ctx.product.tropes
    : [];

  let hits = 0;

  userProfile.tropes.forEach(value => {

    if (!productTropes.includes(value)) return;

    hits++;

    ctx.score += CONFIG.SCORE.trope;

    addReason(
      ctx,
      "trope",
      "❤️ Trope passt",
      value
    );

  });

  ctx.score += hits * CONFIG.SCORE.extraTrope;

}


function scoreMoods(ctx, userProfile) {

  const productMoods = Array.isArray(ctx.product.moods)
    ? ctx.product.moods
    : [];

  userProfile.moods.forEach(value => {

    if (!productMoods.includes(value)) return;

    ctx.score += CONFIG.SCORE.mood;

    addReason(
      ctx,
      "mood",
      "🌙 Stimmung passt",
      value
    );

  });

}


function scoreFeatures(ctx, userProfile) {

  const productFeatures = Array.isArray(ctx.product.features)
    ? ctx.product.features
    : [];

  let hits = 0;

  userProfile.features.forEach(value => {

    if (!productFeatures.includes(value)) return;

    hits++;

    ctx.score += CONFIG.SCORE.feature;

    addReason(
      ctx,
      "feature",
      "✨ Merkmal passt",
      value
    );

  });

  ctx.score += hits * CONFIG.SCORE.extraFeature;

}


function scoreSpice(ctx, userProfile) {

  if (
    Number(userProfile.spice) > 0 &&
    Number(ctx.product.spice) > 0 &&
    Number(userProfile.spice) === Number(ctx.product.spice)
  ) {

    ctx.score += CONFIG.SCORE.spice;

    addReason(
      ctx,
      "spice",
      "🌶 Spice passt",
      "Spice"
    );

  }

}


function scoreSeries(ctx, userProfile) {

  if (
    userProfile.series &&
    ctx.product.series === userProfile.series
  ) {

    ctx.score += CONFIG.SCORE.series;

    addReason(
      ctx,
      "series",
      "📖 Format passt",
      ctx.product.series
    );

  }

}
  function scoreProduct(product) {
    let score = 0;
    let reasons = [];
if (ownedProductIds.includes(product.id)) {
  return {
    ...product,
    score: -9999,
    completeness: 0,
    matchCount: 0,
    matches: {},
    reasons: [],
    summary: []
  };
}
  const productGenres = Array.isArray(product.genres) ? product.genres : [];
const productTropes = Array.isArray(product.tropes) ? product.tropes : [];
const productMoods = Array.isArray(product.moods) ? product.moods : [];
const productFeatures = Array.isArray(product.features) ? product.features : [];
const productTags = Array.isArray(product.tags) ? product.tags : [];
if (
  refineModes.includes("no_dark") &&
  (
    productGenres.includes("dark_romance") ||
    productTropes.includes("morally_grey") ||
    productMoods.includes("chaotic")
  )
) {
  return {
    ...product,
    score: -9999,
    completeness: 0,
    matchCount: 0,
    matches: {},
    reasons: [],
    summary: []
  };
}
if (
  userProfile.hidePreorders &&
  productTags.includes("Vorbestellung")
) {
  return {
    ...product,
    score: -9999,
    completeness: 0,
    matchCount: 0,
    matches: {},
    reasons: [],
    summary: []
  };
}
    if (
  userProfile.excludeGenres.some(value => productGenres.includes(value)) ||
  userProfile.excludeTropes.some(value => productTropes.includes(value)) ||
  userProfile.excludeFeatures.some(value => productFeatures.includes(value))
) {
  return {
    ...product,
    score: -9999,
    completeness: 0,
    matchCount: 0,
    matches: {},
    reasons: []
  };
}

    const matches = {
      genre: false,
      trope: false,
      mood: false,
      feature: false,
      spice: false,
      series: false
    };
    const summary = [];
let matchCount = 0;
const ctx = createScoreContext(product);

scoreGenres(ctx, userProfile);
scoreTropes(ctx, userProfile);
scoreMoods(ctx, userProfile);
scoreFeatures(ctx, userProfile);
scoreSpice(ctx, userProfile);
scoreSeries(ctx, userProfile);

score = ctx.score;
matches.genre = ctx.matches.genre;
matches.trope = ctx.matches.trope;
matches.mood = ctx.matches.mood;
matches.feature = ctx.matches.feature;
matches.spice = ctx.matches.spice;
matches.series = ctx.matches.series;

reasons.push(...ctx.reasons);
summary.push(...ctx.summary);

if (refineModes.includes("dark")) {
  if (productGenres.includes("dark_romance")) score += 90;
  if (productMoods.includes("dark")) score += 40;
  if (productTropes.includes("morally_grey")) score += 35;
}

if (refineModes.includes("spice")) {
  if (Number(product.spice) >= 2) score += 80;
  if (Number(product.spice) === 3) score += 40;
}

if (refineModes.includes("cozy")) {
  if (productGenres.includes("cozy_romance")) score += 80;
  if (productMoods.includes("cozy")) score += 50;
  if (productMoods.includes("humor")) score += 30;
}

if (refineModes.includes("sports")) {
  if (productGenres.includes("sports_romance")) score += 90;
  if (productFeatures.includes("hockey")) score += 35;
  if (productFeatures.includes("football")) score += 35;
}

if (refineModes.includes("fantasy")) {
  if (productGenres.includes("romantasy")) score += 80;
  if (productGenres.includes("fantasy")) score += 60;
  if (productFeatures.includes("magic")) score += 35;
}
matchCount = Object.values(matches).filter(Boolean).length;

// Bonus für Bücher, die viele Wünsche gleichzeitig erfüllen
score += matchCount * 12;
    const completeness =
      (productGenres.length ? 1 : 0) +
      (productTropes.length ? 1 : 0) +
      (productMoods.length ? 1 : 0) +
      (productFeatures.length ? 1 : 0) +
(Number(product.spice) > 0 ? 1 : 0) +
      (product.series ? 1 : 0);

    score += completeness * 2;

matchCount = Object.values(matches).filter(Boolean).length;
// Bücher ohne Genretreffer etwas nach hinten schieben
if (userProfile.genres.length && !matches.genre) {
  score = Math.max(score, 0);
}
return {
  ...product,
  score,
  completeness,
  matches,
  matchCount,
reasons: [...new Set(reasons)],
summary: [...new Set(summary)]
};
  }

function getReaderTypes() {
  const entries = Object.entries(userProfile.reader)
    .sort((a, b) => b[1] - a[1]);

  const total = entries.reduce((sum, [, value]) => sum + value, 0) || 1;

  return entries.map(([key, value]) => ({
    ...readerTypes[key],
    percent: Math.round((value / total) * 100)
  }));
}

function getReaderType() {
  return getReaderTypes()[0];
}

function createRecommendationId() {
  const timestamp = Date.now().toString(36).toUpperCase();
  const randomPart = Math.random().toString(36).slice(2, 8).toUpperCase();

  return `BM-${timestamp}-${randomPart}`;
}

function getProductHandle(product) {
  if (product.handle) return String(product.handle);

  try {
    const pathParts = new URL(product.url, window.location.origin)
      .pathname
      .split("/")
      .filter(Boolean);

    return pathParts[pathParts.length - 1] || String(product.id);
  } catch (error) {
    return String(product.id);
  }
}

function getMatchPercent(product) {
  return Math.max(
    CONFIG.MATCH_PERCENT.min,
    Math.min(
      CONFIG.MATCH_PERCENT.max,
      Math.round(product.score * CONFIG.MATCH_PERCENT.factor)
    )
  );
}

function createCompactRecommendationList(scoredProducts) {
  const compactList = scoredProducts
    .slice(0, CONFIG.MAX_RESULTS)
    .map((product, index) => {
      const handle = getProductHandle(product)
        .replace(/[;|:]/g, "-")
        .slice(0, 40);

      return `${index + 1}:${handle}|${getMatchPercent(product)}`;
    })
    .join(";");

  return compactList.slice(0, RECOMMENDATION_LIST_MAX_LENGTH);
}

function updateBookMatchSession(scoredProducts) {
  const topProduct = scoredProducts[0] || null;

  window.BookMatchSession = {
    recommendationId: createRecommendationId(),
    recommendationList: createCompactRecommendationList(scoredProducts),
    createdAt: new Date().toISOString(),
    version: BOOKMATCH_TRACKING_VERSION,
    resultCount: scoredProducts.length,
    topRecommendation: topProduct
      ? getProductHandle(topProduct)
      : "Keine"
  };

  return window.BookMatchSession;
}

function cleanTrackingValue(value, fallback = "Nicht gewählt") {
  if (Array.isArray(value)) {
    const cleaned = [...new Set(value.filter(Boolean))];
    return cleaned.length ? cleaned.join(", ") : fallback;
  }

  if (value === true) return "Ja";
  if (value === false) return "Nein";
  if (value === null || value === undefined || value === "") return fallback;

  return String(value);
}
function getBookMatchMatchBand(percent) {
  const value = Number(percent);

  if (value >= 95) return "95 bis 99";
  if (value >= 90) return "90 bis 94";
  if (value >= 85) return "85 bis 89";
  if (value >= 80) return "80 bis 84";
  if (value >= 70) return "70 bis 79";

  return "Unter 70";
}

function getPrimaryGenre() {
  if (!Array.isArray(userProfile.genres) || !userProfile.genres.length) {
    return "Nicht gewählt";
  }

  return userProfile.genres[0];
}
function getBookMatchTracking(position, percent) {
  const readerType = getReaderType();

  const session = window.BookMatchSession || {
    recommendationId: "Nicht vorhanden",
    recommendationList: "Nicht vorhanden",
    createdAt: new Date().toISOString(),
    resultCount: 0,
    topRecommendation: "Keine"
  };

  return {
    source: "BookMatch",
    version: BOOKMATCH_TRACKING_VERSION,

    recommendationId: session.recommendationId,
    recommendationList: session.recommendationList,
    recommendationCreatedAt: session.createdAt,
    resultCount: cleanTrackingValue(session.resultCount, "0"),
    topRecommendation: cleanTrackingValue(
      session.topRecommendation,
      "Keine"
    ),

    position: cleanTrackingValue(position),
    match: cleanTrackingValue(percent),
    matchBand: getBookMatchMatchBand(percent),

    readerType: readerType?.title?.trim() || "Nicht ermittelt",

    primaryGenre: getPrimaryGenre(),
    genres: cleanTrackingValue(userProfile.genres),
    tropes: cleanTrackingValue(userProfile.tropes),
    moods: cleanTrackingValue(userProfile.moods),
    features: cleanTrackingValue(userProfile.features),

    path: cleanTrackingValue(userProfile.path),
    spice: cleanTrackingValue(userProfile.spice),
    series: cleanTrackingValue(userProfile.series),

    excludedGenres: cleanTrackingValue(
      userProfile.excludeGenres,
      "Keine"
    ),

    refinements: cleanTrackingValue(refineModes, "Keine"),

    preordersHidden: userProfile.hidePreorders ? "Ja" : "Nein",

    ownedBooksExcluded: cleanTrackingValue(
      ownedProductIds.length,
      "0"
    )
  };
}
function getLineItemProperties(tracking) {
  return {
    "_Quelle": tracking.source,
    "_BM Version": tracking.version,

    "_BM Empfehlungs-ID": tracking.recommendationId,
    "_BM Empfehlungszeitpunkt": tracking.recommendationCreatedAt,
    "_BM Ergebnisliste": tracking.recommendationList,
    "_BM Ergebnisanzahl": tracking.resultCount,
    "_BM Top Empfehlung": tracking.topRecommendation,

    "_BM Trefferposition": tracking.position,
    "_BM Match": `${tracking.match}%`,
    "_BM Matchbereich": tracking.matchBand,

    "_BM Lesetyp": tracking.readerType,

    "_BM Hauptgenre": tracking.primaryGenre,
    "_BM Genre": tracking.genres,
    "_BM Tropes": tracking.tropes,
    "_BM Stimmung": tracking.moods,
    "_BM Merkmale": tracking.features,

    "_BM Pfad": tracking.path,
    "_BM Spice": tracking.spice,
    "_BM Reihenwunsch": tracking.series,

    "_BM Ausschlüsse": tracking.excludedGenres,
    "_BM Verfeinerungen": tracking.refinements,

    "_BM Vorbestellungen ausgeblendet":
      tracking.preordersHidden,

    "_BM Besitzte Bücher ausgeschlossen":
      tracking.ownedBooksExcluded,

    "_BM Kaufweg": "Direkt aus BookMatch"
  };
}

function getCartAttributes(tracking) {
  return {
    "BookMatch": "Ja",
    "BookMatch Lesetyp": tracking.readerType,
    "BookMatch Hauptgenre": tracking.primaryGenre,
    "BookMatch Spice": tracking.spice,
    "BookMatch Trefferposition": tracking.position,
    "BookMatch Matchbereich": tracking.matchBand,
    "BookMatch Kaufweg": "Direkt aus BookMatch"
  };
}
async function updateBookMatchCartAttributes(tracking) {
  const response = await fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      attributes: getCartAttributes(tracking)
    })
  });

  const data = await response.json();

  if (!response.ok) {
    throw data;
  }

  return data;
}

 function createRecommendationText(product) {

  const text = [];
const prettyReasons = product.reasons
  .map(prettify)
  .filter(reason => reason !== "Spice passt");

const topReasons = prettyReasons.slice(0, 3);
  if (product.matches.genre) {
    text.push("📚 genau dein Lieblingsgenre trifft.");
  }

  if (product.matches.trope) {
    text.push("💖 mehrere deiner Lieblingstropes enthält.");
  }

  if (product.matches.mood) {
    text.push("🌙 die Stimmung perfekt zu deinem Lesegeschmack passt.");
  }

  if (product.matches.feature) {
    text.push("✨ genau die Besonderheiten mitbringt, nach denen du suchst.");
  }

  if (product.matches.spice) {
    text.push("🌶️ das Spice-Level genau deinen Geschmack trifft.");
  }

  if (product.matches.series) {
    if (product.series === "Einzelband") {
      text.push("📖 eine abgeschlossene Geschichte erzählt.");
    } else {
      text.push("📚 eine Reihe ist, in der du versinken kannst.");
    }
  }

  if (!text.length) {
    return "📚 Dieses Buch passt insgesamt gut zu deinen Antworten.";
  }

 if (topReasons.length) {
  return `Ich glaube, dieses Buch passt zu dir, weil du ${topReasons.join(", ")} magst.`;
}

if (!text.length) {
  return "📚 Dieses Buch passt insgesamt gut zu deinen Antworten.";
}

return `Ich glaube, dieses Buch passt zu dir, weil ${text[0]}`;
}

  function prettify(value) {
    const labels = {
      dark_romance: "Dark Romance",
      romance: "Romance",
      romantasy: "Romantasy",
      fantasy: "Fantasy",
      sports_romance: "Sports Romance",
      cozy_romance: "Cozy Romance",
      contemporary_romance: "Contemporary Romance",
      romantic_suspense: "Romantic Suspense",
      enemies_to_lovers: "Enemies to Lovers",
      fake_dating: "Fake Dating",
      forced_proximity: "Forced Proximity",
      found_family: "Found Family",
      only_one_bed: "Only One Bed",
      slow_burn: "Slow Burn",
      morally_grey: "Morally Grey",
      friends_to_lovers: "Friends to Lovers",
      grumpy_sunshine: "Grumpy x Sunshine",
      touch_her_and_die: "Touch Her and Die",
      second_chance: "Second Chance",
      why_choose: "Why Choose",
      forbidden_love: "Forbidden Love",
      dark: "düstere Stimmung",
      emotional: "emotional",
      humor: "humorvoll",
      cozy: "cozy",
      suspense: "spannend",
      heartbreaking: "herzzerreißend",
      light: "locker",
      chaotic: "abgefuckt",
      mafia: "Mafia",
      college: "College",
      university: "Universität",
      academy: "Akademie",
      urban_fantasy: "Urban Fantasy",
      royalty: "Königshaus",
      time_travel: "Zeitreise",
      dystopia: "Dystopie",
      vampire: "Vampire",
      werewolf: "Werwölfe",
      dragon: "Drachen",
      fae: "Fae",
      witch: "Hexen",
      demon: "Dämonen",
      magic: "Magie",
      gods: "Götter",
      monster: "Monster",
      military: "Militär",
      football: "Football",
      hockey: "Hockey",
      small_town: "Kleinstadt",
      big_city: "Großstadt",
      Spice: "Spice passt",
      Einzelband: "Einzelband",
      Reihe: "Reihe"
    };

    return labels[value] || String(value).replaceAll("_", " ");
  }

  function renderMatchChip(icon, label, isMatch) {
    return `
      <span class="bm-match-chip ${isMatch ? "is-match" : "is-miss"}">
        ${icon} ${label} ${isMatch ? "✓" : "○"}
      </span>
    `;
  }

  function saveReaderType(readerType) {
    try {
      localStorage.setItem("bm_last_reader_type", JSON.stringify({
        title: readerType.title,
        text: readerType.text,
        date: new Date().toISOString()
      }));
    } catch (error) {
      console.warn("Bookmatch Lesetyp konnte nicht gespeichert werden.", error);
    }
  }

  function showReturningReader() {
    if (!startScreen || !startButton) return;

    let saved = null;

    try {
      saved = JSON.parse(localStorage.getItem("bm_last_reader_type"));
    } catch (error) {
      return;
    }

    if (!saved || !saved.title) return;

    const existing = startScreen.querySelector(".bm-returning-reader");
    if (existing) existing.remove();

    const box = document.createElement("div");
    box.className = "bm-returning-reader";
box.innerHTML = `
  <p>Willkommen zurück ✨</p>
  <strong>Dein letzter Lesetyp war ${saved.title}</strong>
  <small>Starte Bookmatch erneut und finde heraus, ob heute ein anderes Buch zu dir passt.</small>
`;

const startActions = document.querySelector(".bm-start-actions");

if (startActions) {
  startActions.before(box);
}
  }
function animateMatchPercent() {

  document.querySelectorAll("[data-match-percent]").forEach(el => {

    const target = Number(el.dataset.matchPercent);
    let current = 0;

    const timer = setInterval(() => {

      current += Math.max(1, Math.ceil((target - current) / 10));

      if (current >= target) {
        current = target;
        clearInterval(timer);
      }

      el.textContent = current + " %";

    }, 25);

  });

}
  function renderResults() {
    const readerType = getReaderType();
    const readerTypes = getReaderTypes();
    saveReaderType(readerType);

    readerTypeEl.className = `bm-reader-title bm-reader-${readerType.color}`;
    readerTypeEl.textContent = readerType.title;
    readerTextEl.textContent = readerType.text;
if (readerCardEl) {
  readerCardEl.className = `bm-reader-card bm-reader-card-${readerType.color}`;
}

if (readerIconEl) {
  readerIconEl.textContent = readerType.icon || "📚";
}
    if (readerVibeEl && readerType.vibe) {
      const breakdown = readerTypes
  .filter(type => type.percent > 0)
  .slice(0, 3)
  .map(type => `${type.icon} ${type.title.trim()} ${type.percent}%`)
  .join("<br>");
readerVibeEl.innerHTML = `
  <p>Dein Leseprofil:</p>
  <div class="bm-reader-breakdown">
    ${breakdown}
  </div>

  <p>Dein perfekter Leseabend:</p>
  <div>
    ${readerType.vibe.map(item => `<span>${item}</span>`).join("")}
  </div>
`;
    }
const preorderHint = userProfile.hidePreorders
  ? `
    <div class="bm-preorder-toggle">
      <p>Vorbestellungen werden gerade ausgeblendet.</p>
      <button type="button" data-bm-show-preorders>
        Vorbestellungen doch anzeigen
      </button>
    </div>
  `
  : "";
const scored = products
  .map(scoreProduct)
  .filter(product => product.completeness > 0)
.sort((a, b) => {
  return b.score - a.score;
})
.slice(0, CONFIG.MAX_RESULTS);

    if (!scored.length) {
      window.BookMatchSession = null;
      resultsEl.innerHTML = `<p>Noch keine passenden Produkte gefunden. Wahrscheinlich brauchen mehr Bücher Bookmatch-Daten.</p>`;
      showScreen("result");
      return;
    }

updateBookMatchSession(scored);

resultsEl.innerHTML = preorderHint + scored.map((product, index) => {
const percent = Math.max(
  CONFIG.MATCH_PERCENT.min,
  Math.min(
    CONFIG.MATCH_PERCENT.max,
    Math.round(product.score * CONFIG.MATCH_PERCENT.factor)
  )
);
let confidence = "✨ Gute Empfehlung";

if (percent >= 95) {
  confidence = "🟢 Sehr sichere Empfehlung";
} else if (percent >= 88) {
  confidence = "💜 Das dürfte genau dein Ding sein";
} else if (percent >= 78) {
  confidence = "🟡 Überraschungstipp";
}
      const medal = ["🥇", "🥈", "🥉"][index] || "✨";
    const isTopMatch = index === 0;  const resultTitle = index === 0
  ? "📚 Ich habe dein nächstes Lieblingsbuch gefunden."
  : "Vielleicht gefällt dir außerdem:";
const compact = index >= CONFIG.COMPACT_FROM;
if (compact) {
  return `
    <div class="bm-result-row" data-product-url="${product.url}">
      <div class="bm-result-rank">${index + 1}</div>

      ${product.image ? `
        <img
          class="bm-result-row-image"
          src="${product.image}"
          alt="${product.title}">
      ` : ""}

      <div class="bm-result-row-content">

        <div class="bm-result-row-top">
<h3>${product.title}</h3>

${product.tags.includes("Bestseller") ? `
<div class="bm-product-badge bm-product-badge-small">
  🔥 Bestseller
</div>
` : ""}
${product.tags.includes("Vorbestellung") ? `
<div class="bm-availability bm-availability-small preorder">
  🟣 Vorbestellung
</div>
` : product.available ? `
<div class="bm-availability bm-availability-small available">
  🟢 Sofort lieferbar
</div>
` : `
<div class="bm-availability bm-availability-small unavailable">
  ⚪ Nicht auf Lager
</div>
`}

<span class="bm-result-row-percent">
  ${percent}%
</span>

<button
  type="button"
  class="bm-result-row-cart-button"
  data-variant-id="${product.variant_id || ""}"
  data-bm-position="${index + 1}"
  data-bm-percent="${percent}"
  aria-label="In den Warenkorb"
>
  🛒
</button>
        </div>

        <div class="bm-result-row-tags">
          ${product.summary.slice(0,2).map(tag => `<span>${tag}</span>`).join("")}
        </div>

      </div>

      <div class="bm-result-row-arrow">›</div>
    </div>
  `;
}
      const matchLabel = ["Dein perfektes Match", "Weitere Empfehlung", "Weitere Empfehlung"][index] || "Auch passend";
      const matchStrength = percent >= 90 ? "strong" : percent >= 75 ? "good" : "soft";

      return `
${index === 0 ? `<h3 class="bm-result-section-title">${resultTitle}</h3>` : ""}
${index === 1 ? `<h3 class="bm-result-section-title bm-result-section-secondary">${resultTitle}</h3>` : ""}

<div class="bm-result-card ${index === 0 ? "bm-result-card-main" : ""} ${compact ? "bm-result-card-compact" : ""}" data-product-url="${product.url}">
          ${product.image ? `<img src="${product.image}" alt="${product.title}">` : ""}
          <div>
<p class="bm-result-medal">
  ${medal} ${matchLabel}
</p>

${isTopMatch ? `
<div class="bm-top-match-badge">
  ⭐ Unsere beste Empfehlung für dich
</div>
` : ""}
            <p class="bm-confidence">${confidence}</p>
<p
  class="bm-result-percent"
  data-match-percent="${percent}"
>
  0 %
</p>

<div class="bm-match-bar">
  <div class="bm-match-bar-fill bm-match-${matchStrength}" style="width:${percent}%"></div>
</div>
<h3>${product.title}</h3>
<h3>${product.title}</h3>

${product.tags.includes("Bestseller") ? `
<div class="bm-product-badge">
  🔥 Bestseller
</div>
` : ""}

${product.tags.includes("Vorbestellung") ? `
<div class="bm-availability preorder">
  🟣 Vorbestellung
</div>
` : product.available ? `
<div class="bm-availability available">
  🟢 Sofort lieferbar
</div>
` : `
<div class="bm-availability unavailable">
  ⚪ Nicht auf Lager
</div>
`}
            <p class="bm-result-explanation">${createRecommendationText(product)}</p>
<div class="bm-match-summary">
  ${product.summary
    .slice(0, 3)
    .map(item => `<span>${item}</span>`)
    .join("")}
</div>
${product.reasons.length ? `
  <div class="bm-result-reasons">
    <p>Warum passt es?</p>
    <div class="bm-reason-tags">
      ${product.reasons.slice(0, 5).map(reason => `<span>✓ ${prettify(reason)}</span>`).join("")}
    </div>
` : `<div class="bm-result-reasons">`}

              <div class="bm-match-grid">
                ${renderMatchChip("📚", "Genre", product.matches?.genre)}
                ${renderMatchChip("❤️", "Trope", product.matches?.trope)}
                ${renderMatchChip("🌙", "Stimmung", product.matches?.mood)}
                ${renderMatchChip("✨", "Merkmal", product.matches?.feature)}
                ${renderMatchChip("🌶", "Spice", product.matches?.spice)}
                ${renderMatchChip("📖", "Reihe", product.matches?.series)}
              </div>
            </div>

<div class="bm-result-button-row">
  <a class="bm-result-link" href="${product.url}">Zum Buch</a>

  <button
    type="button"
    class="bm-result-cart-button"
    data-variant-id="${product.variant_id || ""}"
    data-bm-position="${index + 1}"
    data-bm-percent="${percent}"
  >
    🛒 In den Warenkorb
  </button>
</div>

<button
  class="bm-share-button"
  data-share-book="${product.title}"
  data-share-percent="${percent}"
>
💬 Ergebnisliste via WhatsApp teilen
</button>
          </div>
        </div>
      `;
    }).join("");

    showScreen("result");
    animateMatchPercent();
  }

  startButton?.addEventListener("click", () => {
    currentQuestion = 0;
    answerHistory = [];
    userProfile = createEmptyProfile();
    refineModes = [];
    window.BookMatchSession = null;
    showScreen("quiz");
    renderQuestion();
    document.getElementById("bookmatch-app")?.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  restartButton?.addEventListener("click", () => {
    currentQuestion = 0;
    answerHistory = [];
    userProfile = createEmptyProfile();
    refineModes = [];
    window.BookMatchSession = null;
    showScreen("start");
    showReturningReader();
    document.getElementById("bookmatch-app")?.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  backButton?.addEventListener("click", () => {
    if (currentQuestion === 0) return;
    answerHistory.pop();
    userProfile = rebuildProfile(answerHistory);
    currentQuestion -= 1;
    renderQuestion();
  });
document.addEventListener("click", event => {
  if (event.target.closest("button")) return;

  const card = event.target.closest(".bm-result-card, .bm-result-row");
  if (!card) return;

  const link = event.target.closest(".bm-result-link");
  const url = link?.href || card.dataset.productUrl;

  if (!url) return;

  const resultElements = Array.from(
    document.querySelectorAll(".bm-result-card, .bm-result-row")
  );

  const position = resultElements.indexOf(card) + 1;

  const percentText =
    card.querySelector("[data-match-percent]")?.dataset.matchPercent ||
    card.querySelector(".bm-result-row-percent")?.textContent ||
    "";

  const percent = Number(String(percentText).replace(/\D/g, "")) || 0;

  const productTitle =
    card.querySelector("h3")?.textContent?.trim() || "Unbekannt";

  const tracking = getBookMatchTracking(position, percent);

  try {
    sessionStorage.setItem(
      "bm_pending_product_tracking",
      JSON.stringify({
        url,
        productTitle,
        tracking,
        savedAt: Date.now()
      })
    );
  } catch (error) {
    console.warn(
      "BookMatch Produkttracking konnte nicht gespeichert werden.",
      error
    );
  }

  if (!link) {
    window.location.href = url;
  }
});
document.addEventListener("click", event => {

  const button = event.target.closest(".bm-share-button");

  if (!button) return;

 const topResults = Array.from(document.querySelectorAll(".bm-result-card, .bm-result-row"))
  .slice(0, 10)
  .map((item, index) => {
    const title = item.querySelector("h3")?.textContent?.trim() || "";
    const percent =
      item.querySelector(".bm-result-percent")?.textContent?.trim() ||
      item.querySelector(".bm-result-row-percent")?.textContent?.trim() ||
      "";

    return `${index + 1}. ${title} ${percent}`;
  })
  .join("\n");

const text =
`Ich habe gerade den BookMatch bei Buchmädchen gemacht 📚

Meine Ergebnisliste:

${topResults}

Mach den Test auch:
https://buchmaedchen.de/pages/bookmatch`;

  window.open(
    "https://wa.me/?text=" + encodeURIComponent(text),
    "_blank"
  );

});
document.addEventListener("click", event => {
  const button = event.target.closest("[data-bm-show-preorders]");
  if (!button) return;

  userProfile.hidePreorders = false;
  userProfile.showPreorders = true;

  renderResults();
});
document.addEventListener("click", async event => {
  const button = event.target.closest(".bm-result-cart-button, .bm-result-row-cart-button");
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const originalButtonText = button.textContent;
  const tracking = getBookMatchTracking(
    Number(button.dataset.bmPosition),
    Number(button.dataset.bmPercent)
  );

  button.textContent = "Wird hinzugefügt …";
  button.disabled = true;

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(button.dataset.variantId),
            quantity: 1,
            properties: getLineItemProperties(tracking)
          }
        ]
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw data;
    }

    await updateBookMatchCartAttributes(tracking);

    button.textContent = "Im Warenkorb ✓";
  } catch (error) {
    console.error("BookMatch Produkt konnte nicht hinzugefügt werden.", error);
    button.textContent = "Fehler beim Hinzufügen";
    button.disabled = false;

    setTimeout(() => {
      button.textContent = originalButtonText;
    }, 2500);
  }
});
ownedToggle?.addEventListener("click", () => {
  ownedBox.hidden = !ownedBox.hidden;

  if (!ownedBox.hidden) {
    renderOwnedList();
  }
});

ownedSearch?.addEventListener("input", () => {
  renderOwnedList(ownedSearch.value);
});

ownedList?.addEventListener("click", event => {
  const button = event.target.closest("[data-owned-product-id]");
  if (!button) return;

  const id = Number(button.dataset.ownedProductId);

 if (ownedProductIds.includes(id)) {
  ownedProductIds = ownedProductIds.filter(item => item !== id);
} else {
  ownedProductIds.push(id);
}

if (ownedToggle) {
  ownedToggle.textContent = ownedProductIds.length
    ? `📚 ${ownedProductIds.length} Bücher ausgeschlossen`
    : "Ich besitze bereits Bücher";
}

renderOwnedList(ownedSearch?.value || "");
});

ownedSkip?.addEventListener("click", () => {
  ownedBox.hidden = true;
});
refineButtons.forEach(button => {
  button.addEventListener("click", () => {
    const mode = button.dataset.bmRefine;

    if (refineModes.includes(mode)) {
      refineModes = refineModes.filter(item => item !== mode);
      button.classList.remove("is-active");

      if (mode === "no_dark") {
        button.textContent = "🌸 Ohne Dark Romance";
      }

    } else {
      refineModes.push(mode);
      button.classList.add("is-active");

      if (mode === "no_dark") {
        button.textContent = "🖤 Dark Romance wieder anzeigen";
      }
    }

    renderResults();
  });
});
  showReturningReader();
  console.log("Bookmatch Produkte:", products);
});
